import { Area } from "../../../types";

export const snapContentInContainer = (
  contentArea: Area,
  containerArea: Area,
  direction: "width" | "height",
): Area => {
  const newContentArea = { ...contentArea };

  if (direction === "width") {
    // Snap to width: scale image to fit clear area width
    const scale = containerArea.width / newContentArea.width;
    newContentArea.width = containerArea.width;
    newContentArea.height = newContentArea.height * scale;
    // Position top-left corner of image at top-left corner of clear area
    newContentArea.x = containerArea.x;
    newContentArea.y = containerArea.y;
  } else {
    // Snap to height: scale image to fit clear area height
    const scale = containerArea.height / newContentArea.height;
    newContentArea.height = containerArea.height;
    newContentArea.width = newContentArea.width * scale;
    // Position top-left corner of image at top-left corner of clear area
    newContentArea.x = containerArea.x;
    newContentArea.y = containerArea.y;
  }

  return newContentArea;
};
